import { array, mixed, number, object, string } from 'yup'
import { DestinationType } from '../../shared/types'
import {
  CallDetailsBreakdownLocation,
  CallDetailsComment,
  CallDetailsContact,
  CallDetailsResponse,
  CallDetailsService,
  CallDetailsServiceTracking,
  CallDetailsTowDestination,
  CallDetailsVehicle,
  CallResponse
} from './calls.types'

export const ContactSchema = object().shape({
  firstName: string().min(1).required(),
  lastName: string().min(2).required(),
  contactType: string().oneOf(['SYSTEM', 'CUSTOMER', 'TOWDEST', 'DRIVER', 'FACILITY']).required(),
})

export const CallResponseSchema = object<CallResponse>().shape({
  callKey: string().required(),
})

export const CallDetailsContactSchema = object<CallDetailsContact>().shape({
  firstName: string().optional(),
  lastName: string().optional(),
  phones: array().of(
    object().shape({
      phoneNumber: string().optional()
    })
  ).optional()
})

export const CallDetailsVehicleSchema = object<CallDetailsVehicle>().shape({
  year: number().integer().min(1900).max(2999).required(),
  make: string().min(1, 'Make is required').required(),
  model: string().min(1, 'Model is required').required(),
  color: string().min(1, 'Color is required').required()
})

export const CallDetailsServiceSchema = object<CallDetailsService>().shape({
  issueType: string().optional(),
  pacesetterCode: string().optional(),
  numberOfPassengers: number().optional(),
  status: string().optional(),
  pta: string().optional(),
  eta: string().optional()
})

export const CallDetailsBreakdownLocationSchema = object<CallDetailsBreakdownLocation>().shape({
  streetNumber: string().optional(),
  streetName: string().min(1, 'Street name is required').required(),
  city: string().min(1, 'City is required').required(),
  state: string().min(1, 'State is required').required(),
  country: string().optional(),
  postalCode: string().min(1, 'Postal code is required').required(),
  latitude: number().min(-90).max(90).required(),
  longitude: number().min(-180).max(180).required(),
  driverDirections: string().optional()
})

export const CallDetailsTowDestinationSchema = object<CallDetailsTowDestination>().shape({
  streetName: string().optional(),
  streetNumber: string().optional(),
  city: string().optional(),
  state: string().optional(),
  postalCode: string().optional(),
  location: string().optional(),
  country: string().optional(),
  id: string().optional(),
  type: mixed<DestinationType>().oneOf(Object.values(DestinationType)).optional(),
  fullAddress: string().optional(),
  latitude: number().min(-90).max(90).optional(),
  longitude: number().min(-180).max(180).optional()
})

export const CallDetailsCommentSchema = object<CallDetailsComment>().shape({
  text: string().optional()
})

export const CallDetailsServiceTrackingSchema = object<CallDetailsServiceTracking>().shape({
  system: string().optional(),
  link: string().optional()
})

export const CallDetailsResponseSchema = object<CallDetailsResponse>().shape({
  callKey: string().min(1, 'Call key is required').required(),
  contact: CallDetailsContactSchema.optional(),
  vehicle: CallDetailsVehicleSchema.required(),
  service: CallDetailsServiceSchema.required(),
  breakdownLocation: CallDetailsBreakdownLocationSchema.required(),
  towDestination: CallDetailsTowDestinationSchema.optional(),
  comments: array().of(CallDetailsCommentSchema).optional(),
  serviceTracking: CallDetailsServiceTrackingSchema.optional()
})
